import React, { lazy, PropsWithChildren, Suspense } from 'react'
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store/reducers'
import { updateToken, updateUserId } from '../store/actions'

const EXAM_PREFIX = '/exam' // 考试系统前缀
export enum ROUTES {
  ROOT = '/',
  HOME = '/home',

  /* 考试人脸识别相关 */
  EXAM_LOGIN = `/exam/login`,
  EXAM_AGREEMENT = `/exam/agreement`,
  EXAM_FACE_COLLECT = `/exam/face-collect`,
  EXAM_FORGET_PASSWORD = `/exam/forget-password`,
  EXAM_ATTEND = `/exam/attend`
}

const AUTH_ROUTES = [ROUTES.HOME, ROUTES.EXAM_FACE_COLLECT]
// const NO_AUTH_ROUTES = [
//   ROUTES.EXAM_LOGIN,
//   ROUTES.EXAM_AGREEMENT,
//   ROUTES.EXAM_FORGET_PASSWORD,
//   ROUTES.EXAM_ATTEND
// ]

// 错误处理页面
const ErrorBoundary = lazy(() => import('../components/ErrorBoundary'))
// 首页
const Home = lazy(() => import('../components/Home'))
// 信息采集登录
const Login = lazy(() => import('../components/Exam/Login'))
// 信息采集协议
const Agreement = lazy(() => import('../components/Exam/Agreement'))
// 信息采集
const FaceCollect = lazy(() => import('../components/Exam/FaceCollect'))
// 忘记密码
const ForgetPassword = lazy(() => import('../components/Exam/ForgetPassword'))
// 参加考试
const AttendExam = lazy(() => import('../components/Exam/AttendExam'))

function SessionChecker(props: PropsWithChildren<{}>) {
  const dispatch = useDispatch()
  const history = useHistory()
  const token = useSelector<RootState, string | null>((state) => state.userInfo.token)
  const userId = useSelector<RootState, string | null>((state) => state.userInfo.userId)

  /* 未登录 */
  if (token === null || userId === null) {
    const savedToken = window.sessionStorage.getItem('token')
    const savedUserId = window.sessionStorage.getItem('userId')
    if (savedToken && savedUserId) {
      dispatch(updateToken(savedToken))
      dispatch(updateUserId(savedUserId))
      return <>{props.children}</>
    } else {
      /* 访问禁止页面 */
      if (AUTH_ROUTES.findIndex((path) => history.location.pathname.startsWith(path)) >= 0) {
        if (history.location.pathname.startsWith(EXAM_PREFIX)) {
          /* 考试页面 */
          history.replace({
            pathname: ROUTES.EXAM_LOGIN,
            search: history.location.search,
            state: history.location.state
          })
        } else {
          history.replace({
            pathname: ROUTES.ROOT,
            search: history.location.search,
            state: history.location.state
          })
        }
        return null
      } else {
        return <>{props.children}</>
      }
    }
  } else {
    /* 已登录 可访问所有页面 */
    window.sessionStorage.setItem('token', token)
    window.sessionStorage.setItem('userId', userId)
    return <>{props.children}</>
  }
}

export default function getRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <ErrorBoundary>
          <SessionChecker>
            <Switch>
              <Route exact path={ROUTES.ROOT} component={Home} />
              <Route path={ROUTES.HOME} component={Home} />
              <Route path={ROUTES.EXAM_LOGIN} component={Login} />
              <Route path={ROUTES.EXAM_AGREEMENT} component={Agreement} />
              <Route path={ROUTES.EXAM_FACE_COLLECT} component={FaceCollect} />
              <Route path={ROUTES.EXAM_FORGET_PASSWORD} component={ForgetPassword} />
              <Route path={ROUTES.EXAM_ATTEND} component={AttendExam} />
              <Redirect to={ROUTES.ROOT} />
            </Switch>
          </SessionChecker>
        </ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  )
}
